<template>
  <div class="agreements-list">
    <div v-for="agreementSection in agreements.list" :key="agreementSection.title">
      <h2>{{ agreementSection.title }}</h2>
      <div v-for="agreement in agreementSection.list" :key="agreement.title">
        <v-row>
          <v-col>
            <v-img max-width="200px" class="agreement-image" :src="require('../assets/images/agreements/' + agreement.image)" ></v-img>
          </v-col>
          <v-col>
            <h3>{{ agreement.name }}</h3>
            <p>{{ agreement.description }}</p>
            <v-row>
              <v-col>
                <a :href="agreement.learn">
                 <v-btn color="primary">Averigua más</v-btn>
                </a>
              </v-col>
              <v-col>
                <a :href="agreement.visit">
                 <v-btn color="primary">Visita</v-btn>
                </a>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import agreements from '@/data/agreements.json'

export default {
  data: function () {
    return {
      agreements: agreements
    }
  }
}
</script>

<style scoped>
.agreements-list {
  padding-left: 15vw;
  padding-right: 15vw;
  margin-top: 10vh;
}

.agreement-image {
  margin-left: 25%;
}
</style>
